import { ActionType, ProfileAction, ProfileState } from './types'

export const initialState: ProfileState = {
  item: {},
  selfPlayerIds: [],
  players: [],
  loadedPlayers: false,
  showStats: true,
  isNotificationSettingsOpen: false,
  isEditOpen: false,
}

export const profileReducer = (
  state: ProfileState,
  action: ProfileAction
): ProfileState => {
  switch (action.type) {
    case ActionType.SET_ITEM:
      return {
        ...state,
        item: action.payload,
      }

    case ActionType.SET_PLAYERS:
      return {
        ...state,
        players: action.payload.players,
        selfPlayerIds: action.payload.selfPlayerIds,
        showStats: action.payload.showStats,
        loadedPlayers: true,
      }

    case ActionType.SET_LOADED_PLAYERS:
      return {
        ...state,
        loadedPlayers: action.payload,
      }

    case ActionType.SET_SHOW_STATS:
      return {
        ...state,
        showStats: action.payload,
      }

    case ActionType.SET_NOTIFICATION_SETTINGS_OPEN:
      return {
        ...state,
        isNotificationSettingsOpen: action.payload,
      }

    case ActionType.SET_EDIT_OPEN:
      return {
        ...state,
        isEditOpen: action.payload,
      }

    default:
      return state
  }
}
